import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-error-warning-line text-4xl" />
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-6">页面未找到</h2>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-foreground-500 max-w-md">
          您访问的页面不存在或已被移除，请检查链接是否正确
        </p>
        <Link
          to="/"
          className="inline-block mt-8 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}